/**
 * WhatsApp permite editar mensagem por até 15 minutos após o envio
 * (FAQ oficial). Travamos com margem para evitar falso positivo
 * (UI libera, WhatsApp rejeita por clock skew / latência).
 */
export const WA_EDIT_LIMIT_MS = 15 * 60 * 1000;
export const WA_EDIT_SAFETY_MS = 2 * 60 * 1000;
/** Prazo efetivo na UI/API: 13 minutos. */
export const WA_EDIT_EFFECTIVE_MS = WA_EDIT_LIMIT_MS - WA_EDIT_SAFETY_MS;

const WA_CHANNEL_TYPES = new Set([
  "Channel::Whatsapp",
  "Channel::Api",
]);

export function messageCreatedAtMs(createdAt) {
  const n = Number(createdAt);
  if (!Number.isFinite(n) || n <= 0) return 0;
  // Chatwoot usa epoch em segundos; alguns payloads vêm em ms.
  return n < 1e12 ? n * 1000 : n;
}

export function isWhatsappLikeInbox(inbox = {}) {
  const type = String(inbox.channel_type || inbox.channelType || "");
  if (WA_CHANNEL_TYPES.has(type)) return true;
  if (type === "Channel::TwilioSms") {
    const medium = String(inbox.medium || "").toLowerCase();
    return medium === "whatsapp";
  }
  return false;
}

/**
 * @returns {{ applies: boolean, expired: boolean, remainingMs: number }}
 */
export function whatsappEditWindow(createdAt, inbox, nowMs = Date.now()) {
  if (!isWhatsappLikeInbox(inbox)) {
    return { applies: false, expired: false, remainingMs: Infinity };
  }
  const createdMs = messageCreatedAtMs(createdAt);
  if (!createdMs) {
    // Sem timestamp confiável: trava (evita falso positivo).
    return { applies: true, expired: true, remainingMs: 0 };
  }
  const remainingMs = WA_EDIT_EFFECTIVE_MS - (nowMs - createdMs);
  return {
    applies: true,
    expired: remainingMs <= 0,
    remainingMs: Math.max(0, remainingMs),
  };
}
